import { action } from 'typesafe-actions';
import { CommonTypes } from './types';

export const categoriaRequest = (company: any) =>
  action(CommonTypes.CATEGORIA_RESQUEST, { company });

export const categoriaSuccess = (data: any) =>
  action(CommonTypes.CATEGORIA_SUCCESS, { data });

export const categoriaFailure = () => action(CommonTypes.CATEGORIA_FAILURE, {});
